import { render, staticRenderFns } from "./banner-awaiting-payment.vue?vue&type=template&id=768ef691"
import script from "./banner-awaiting-payment.vue?vue&type=script&lang=js"
export * from "./banner-awaiting-payment.vue?vue&type=script&lang=js"
import style0 from "./banner-awaiting-payment.vue?vue&type=style&index=0&id=768ef691&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports